import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(VTextField, {
    staticClass: "ns-email flex-column",
    class: _vm.$style["ns-email-simple"],
    attrs: {
      name: "email",
      maxlength: _vm.maxLength,
      label: _vm.label,
      disabled: _vm.disabled,
      rules: _vm.emailRules,
      placeholder: _vm.placeholder,
      "validate-on-blur": "",
    },
    model: {
      value: _vm.emailInput,
      callback: function ($$v) {
        _vm.emailInput = $$v
      },
      expression: "emailInput",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }